import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import REACT_APP from "../../environment";
import { TextField } from "formik-material-ui";
import { Grid } from "@mui/material";
import axios from "axios";
import regex from "tts-hrp-val-lib";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

export default function AddProvider({ getProviders }) {
    // eslint-disable-next-line
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const validateCompany = Yup.object({
        name: Yup.string().required("Name is required"),
        email: Yup.string().required("Email is required"),
        website: Yup.string().matches(regex.website, "Enter correct url!"),
    });
    const emptyData = { name: undefined, email: undefined, website: undefined };

    const onSubmit = async (values, setSubmitting) => {
        if (!values.website) delete values.website;
        await axios
            .post(`${REACT_APP.URL}/api/hrp/tts/adm/provider`, values, {
                headers: { Authorization: sessionStorage.getItem("token"), "client-id": REACT_APP.CLIENTID, "client-secret": REACT_APP.SECRET },
            })
            .then((res) => {
                getProviders();
                toast.success("Success!", { autoClose: 2000 });
                handleClose();
            })
            .catch((err) => {
                console.log(err);
                toast.error("An error occurred");
            });
        setSubmitting(false);
    };

    return (
        <div className="addcompany">
            <Button onClick={handleOpen} variant="contained">
                Add provider
            </Button>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { timeout: 500 } }}
            >
                <Fade in={open}>
                    <Box sx={style} className="addcompanymodal">
                        <Typography id="transition-modal-title" variant="h6" component="h2" className="marginBottom">
                            Enter provider's information
                        </Typography>
                        <Formik initialValues={emptyData} validationSchema={validateCompany} onSubmit={onSubmit}>
                            {({ values, errors, isSubmitting }) => (
                                <Form autoComplete="off" className="mt-4">
                                    <Grid container spacing={4}>
                                        <Grid item xs={12} className="marginBottom">
                                            <Field fullWidth label="Company name" name="name" component={TextField} autoComplete="password" type="text" />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className="marginBottom">
                                        <Field fullWidth name="email" label="Company email" autoComplete="email" component={TextField} />
                                    </Grid>
                                    <Grid item xs={12} className="marginBottom">
                                        <Field fullWidth label="Company website (optional)" name="website" component={TextField} type="text" />
                                    </Grid>
                                    <div className="left_right">
                                        <Button onClick={handleClose} variant="contained" sx={{ mt: 3, mb: 2 }} color="error">
                                            Close
                                        </Button>
                                        {isSubmitting ? (
                                            <LoadingButton loading variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                Submit
                                            </LoadingButton>
                                        ) : (
                                            <Button type="submit" className="mt-5" variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                Submit
                                            </Button>
                                        )}
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
